// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"188":"component---src-templates-post-page-jsx","279":"component---src-pages-index-jsx","415":"component---src-pages-404-jsx"}[chunkId] + "-" + {"188":"536ad706246f15d059e9","279":"733568a46c6db558ff5c","415":"01789def98854172a380"}[chunkId] + ".js";
};